export default __webpack_public_path__ + "static/media/googlePlayStoreLinkButtonGraphic.82fba31d.svg";